import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { cateringAPI } from '../../utils/api';

export default function CateringQuote() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    full_name: '',
    phone: '',
    email: '',
    event_date: '',
    venue: '',
    guest_count: '100to300',
    meal_type: 'dinner',
    service_style: 'buffet',
    cuisine_preferences: '',
    dietary_requirements: '',
    package_interest: '',
    additional_services: '',
    description: ''
  });

  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg(null);
    try {
      const res = await cateringAPI.submitQuote(form);
      setMsg({ ok: true, text: res.message || 'Quote submitted! Our team will contact you within 24 hours.' });
      setForm({
        full_name: '', phone: '', email: '', event_date: '', venue: '',
        guest_count: '100to300', meal_type: 'dinner', service_style: 'buffet',
        cuisine_preferences: '', dietary_requirements: '', package_interest: '',
        additional_services: '', description: ''
      });
    } catch {
      setMsg({ ok: false, text: 'Could not submit quote. Please call Krishna Khanal directly at 9867155395.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sec-wrapper" style={{ maxWidth: '880px' }}>
      {/* Unified Vivah Nepal Hero Banner */}
      <section className="hero-section">
        <div className="hero-content">
          <div style={{ marginBottom: '1.2rem' }}>
            <span className="badge-hero-top">
              ✦ SABITRI CATERING & TENT HOUSE ✦
            </span>
          </div>

          <h1 className="hero-title">
            Request a Custom <span className="hero-title-gradient">Catering Quote</span>
          </h1>

          <p className="hero-subtitle">
            Tell us about your event and our master chefs will craft a personalized menu quote within 24 hours. Directed by <strong>Krishna Khanal (9867155395)</strong>.
          </p>

          <div className="hero-cta-group">
            <a href="tel:9867155395" className="btn btn-secondary">
              📞 Call Krishna: 9867155395 →
            </a>
            <button className="btn btn-tertiary" onClick={() => navigate('/catering/menu')}>
              Explore Food Packages →
            </button>
          </div>
        </div>
      </section>

      {/* 3 Step Workflow */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
        gap: '1.2rem',
        marginBottom: '2.5rem'
      }}>
        {[
          ['1', 'Submit Event Details', 'Share date, venue & guest count.'],
          ['2', 'Receive Custom Quote', 'Detailed menu & quote within 24 hrs.'],
          ['3', 'Confirm & Celebrate', 'Book deposit and leave the feast to us!']
        ].map(([step, title, desc]) => (
          <div key={step} className="card" style={{ textAlign: 'center' }}>
            <div style={{
              width: '36px', height: '36px', borderRadius: '50%',
              background: 'linear-gradient(135deg, #9E1B32, #7A1221)',
              color: '#fff', fontWeight: 800, fontSize: '0.9rem',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 0.6rem'
            }}>
              {step}
            </div>
            <h4 style={{ fontFamily: 'var(--serif)', fontSize: '1.1rem', fontWeight: 700, color: '#9E1B32', marginBottom: '0.3rem' }}>
              {title}
            </h4>
            <p style={{ fontSize: '0.82rem', color: '#6E615E', lineHeight: 1.5 }}>
              {desc}
            </p>
          </div>
        ))}
      </div>

      {/* Form Card */}
      <div className="card" style={{ border: '1.5px solid #D4AF37' }}>
        {msg && (
          <div style={{
            background: msg.ok ? '#e8f5e9' : '#FEECEC',
            color: msg.ok ? '#2e7d32' : '#9E1B32',
            border: msg.ok ? '1px solid #a5d6a7' : '1px solid rgba(158,27,50,0.3)',
            borderRadius: '14px', padding: '1rem 1.2rem', marginBottom: '1.5rem',
            fontSize: '0.88rem', fontWeight: 700
          }}>
            {msg.ok ? '✓ ' : '⚠️ '}{msg.text}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {/* Section 1: Client Details */}
          <div style={{ marginBottom: '1.8rem', borderBottom: '1px solid #E8DFD1', paddingBottom: '1.2rem' }}>
            <h3 style={{ fontSize: '1.35rem', fontWeight: 700, color: '#9E1B32', marginBottom: '1rem', fontFamily: 'var(--serif)' }}>
              1. Contact Information
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '1.2rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Full Name *</label>
                <input type="text" className="form-input" value={form.full_name} onChange={handleChange('full_name')} placeholder="e.g. Ramesh Sharma" required />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Phone Number *</label>
                <input type="tel" className="form-input" value={form.phone} onChange={handleChange('phone')} placeholder="e.g. 98XXXXXXXX" required />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Email Address *</label>
                <input type="email" className="form-input" value={form.email} onChange={handleChange('email')} placeholder="you@email.com" required />
              </div>
            </div>
          </div>

          {/* Section 2: Event Details */}
          <div style={{ marginBottom: '1.8rem', borderBottom: '1px solid #E8DFD1', paddingBottom: '1.2rem' }}>
            <h3 style={{ fontSize: '1.35rem', fontWeight: 700, color: '#9E1B32', marginBottom: '1rem', fontFamily: 'var(--serif)' }}>
              2. Event & Venue Specifications
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '1.2rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Event Date *</label>
                <input type="date" className="form-input" value={form.event_date} onChange={handleChange('event_date')} required />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Venue Location *</label>
                <input type="text" className="form-input" value={form.venue} onChange={handleChange('venue')} placeholder="e.g. Butwal Banquet / Palpa" required />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Guest Count</label>
                <select className="form-input" value={form.guest_count} onChange={handleChange('guest_count')}>
                  <option value="below50">Below 50 Guests</option>
                  <option value="50to100">50 – 100 Guests</option>
                  <option value="100to300">100 – 300 Guests</option>
                  <option value="300to500">300 – 500 Guests</option>
                  <option value="500to1000">500 – 1000 Guests</option>
                  <option value="above1000">1000+ Guests</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Meal Type</label>
                <select className="form-input" value={form.meal_type} onChange={handleChange('meal_type')}>
                  <option value="dinner">Dinner Feast</option>
                  <option value="lunch">Lunch Feast</option>
                  <option value="both">Both Lunch & Dinner</option>
                  <option value="cocktail">Cocktail & Snacks</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Service Style</label>
                <select className="form-input" value={form.service_style} onChange={handleChange('service_style')}>
                  <option value="buffet">Buffet Service</option>
                  <option value="plated">Plated Service</option>
                  <option value="family">Traditional Family Style</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Package Interest</label>
                <input type="text" className="form-input" value={form.package_interest} onChange={handleChange('package_interest')} placeholder="e.g. Palpali Bhoj / Royal Buffet" />
              </div>
            </div>
          </div>

          {/* Section 3: Food & Special Requests */}
          <div style={{ marginBottom: '1.8rem' }}>
            <h3 style={{ fontSize: '1.35rem', fontWeight: 700, color: '#9E1B32', marginBottom: '1rem', fontFamily: 'var(--serif)' }}>
              3. Menu & Culinary Preferences
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.2rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Cuisine Preferences</label>
                <input type="text" className="form-input" value={form.cuisine_preferences} onChange={handleChange('cuisine_preferences')} placeholder="e.g. Palpali, Newari, Indian Royal..." />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Dietary Requirements & Notes</label>
                <textarea className="form-input" rows={3} value={form.description} onChange={handleChange('description')} placeholder="Special requirements, live counters, or timing instructions..." />
              </div>
            </div>
          </div>

          <button className="btn btn-primary btn-full" type="submit" disabled={loading} style={{ padding: '0.9rem', fontSize: '1rem' }}>
            {loading ? '⏳ Submitting Quote…' : 'Request My Custom Catering Quote →'}
          </button>
        </form>
      </div>
    </div>
  );
}